module.exports = __webpack_public_path__ + "static/media/blogPostFive.1fb821dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blogPostFive.png
// module id = 43
// module chunks = 0